console.log('Mega Menu Accessibility Script loaded successfully!');

document.addEventListener('DOMContentLoaded', () => {
    const megamenu = document.querySelector('.megamenu');

    if (!megamenu) {
        console.warn("Mega menu element (.megamenu) not found. Keyboard accessibility features may not work.");
        return;
    }

    // Function to close all currently open submenus
    function closeAllOpenSubmenus() {
        const openSubmenus = megamenu.querySelectorAll('li.with-sub-menu.active, li.with-sub-menu.active_click');
        openSubmenus.forEach(li => {
            li.classList.remove('active');
            li.classList.remove('active_click');

            const toggleButton = li.querySelector('.custom_toggle-button');
            if (toggleButton) {
                toggleButton.setAttribute('aria-expanded', 'false');
            }

            const submenu = li.querySelector('.sub-menu');
            if (submenu) {
                // Ensure this matches your CSS for hiding submenus (visibility or display)
                submenu.style.visibility = 'hidden';
                // If you use display: none; in CSS, uncomment the line below and comment the one above:
                // submenu.style.display = 'none';
            }
        });
    }

    // Event listener for keyboard navigation (Tab/Shift+Tab, Enter/Space)
    megamenu.addEventListener('keydown', function(event) {
        const focusedElement = document.activeElement; // The element currently with focus

        // --- NEW ADDITION: Handle Enter/Space key presses on the toggle button for opening/closing ---
        if (focusedElement.classList.contains('custom_toggle-button')) {
            if (event.key === 'Enter' || event.key === ' ') { // Check for Enter or Space key
                event.preventDefault(); // Prevent default scroll behavior for space
                const parentLi = focusedElement.closest('li.with-sub-menu');
                if (parentLi) {
                    const isAlreadyOpen = parentLi.classList.contains('active') || parentLi.classList.contains('active_click');

                    closeAllOpenSubmenus(); // Close other open submenus first (important for single-open menu behavior)

                    if (!isAlreadyOpen) {
                        parentLi.classList.add('active_click'); // Open this one
                        focusedElement.setAttribute('aria-expanded', 'true');
                        const submenu = parentLi.querySelector('.sub-menu');
                        if (submenu) {
                            submenu.style.visibility = 'visible';
                            // If you use display: none; in CSS, uncomment the line below and comment the one above:
                            // submenu.style.display = 'block';

                            // Optional: focus the first focusable element in the opened submenu for better flow
                            // Be careful with auto-focusing on Enter/Space, some users prefer to tab into the submenu.
                            // const firstFocusable = submenu.querySelector('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
                            // if (firstFocusable) {
                            //     firstFocusable.focus();
                            // }
                        }
                    }
                }
            }
        }

        // --- EXISTING AND REFINED LOGIC: Handle Tab key navigation for closing submenus ---
        if (event.key === 'Tab') {
            const isShiftTab = event.shiftKey;

            const focusedLi = focusedElement.closest('li.with-sub-menu');
            const focusedInsideSubmenu = focusedElement.closest('.sub-menu');
            const currentOpenLi = megamenu.querySelector('li.with-sub-menu.active, li.with-sub-menu.active_click');

            // 1. If Shift+Tab is pressed when focus is on the triggering element (button/link)
            //    of an OPEN submenu, close that submenu. This means going backward out of the currently open submenu.
            //    Expanded focusedElement check to include custom_toggle-button specifically.
            if (isShiftTab && focusedLi === currentOpenLi && (focusedElement.tagName === 'A' || focusedElement.tagName === 'BUTTON' || focusedElement.classList.contains('custom_toggle-button'))) {
                if (focusedLi.classList.contains('active') || focusedLi.classList.contains('active_click')) {
                    closeAllOpenSubmenus();
                    // No preventDefault here, focus naturally moves to the previous element
                }
            }
            // 2. If Tab is pressed and the focus is moving *out* of an OPEN submenu
            //    (i.e., from the last focusable element within that submenu).
            else if (!isShiftTab && currentOpenLi && focusedInsideSubmenu === currentOpenLi.querySelector('.sub-menu')) {
                // Get all focusable elements within the *currently open* submenu
                const focusableElementsInCurrentSubmenu = Array.from(currentOpenLi.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
                                                            .filter(el => el.offsetWidth > 0 || el.offsetHeight > 0); // Ensure element is visible

                const lastFocusableElementInSubmenu = focusableElementsInCurrentSubmenu[focusableElementsInCurrentSubmenu.length - 1];

                if (focusedElement === lastFocusableElementInSubmenu) {
                    // If the user is tabbing from the very last element in the open submenu,
                    // the next tab will take them out of it. So, close it.
                    closeAllOpenSubmenus();
                }
            }
            // 3. If Tab is pressed and focus moves to a DIFFERENT main menu item, close previous submenu.
            //    This helps ensure only one submenu is open at a time when tabbing through main menu items.
            else if (!isShiftTab && focusedLi && focusedLi !== currentOpenLi) {
                closeAllOpenSubmenus(); // Close any existing open submenu
            }
            // No specific rule needed here for Shift+Tab from the *first* element in a submenu
            // as that's often the toggle button itself (covered by rule 1) or focus will naturally
            // move back to the toggle button, which then closes the menu on subsequent Shift+Tab.
        }
    });

    // --- NEW ADDITION: Close submenu when focus moves outside the entire megamenu structure ---
    // This uses the 'focusout' event which fires when an element, or any of its descendants, loses focus.
    // It's more reliable for detecting when focus leaves the whole menu.
    megamenu.addEventListener('focusout', function(event) {
        // Use a small timeout to allow the browser to update document.activeElement
        // and correctly determine where the focus has moved to.
        setTimeout(() => {
            // Check if the new active element (where focus landed) is no longer
            // within the megamenu (including its children) AND is not the megamenu itself.
            if (!megamenu.contains(document.activeElement) && document.activeElement !== megamenu) {
                closeAllOpenSubmenus();
            }
        }, 0); // A 0ms timeout defers execution until the current event loop finishes.
    });


    // --- Basic Click Handling for Opening/Closing (Existing code, looks fine for mouse interaction) ---
    megamenu.addEventListener('click', function(event) {
        const toggleButton = event.target.closest('.custom_toggle-button');
        if (toggleButton) {
            event.preventDefault(); // Prevent default link behavior if button wraps an anchor
            const parentLi = toggleButton.closest('li.with-sub-menu');
            if (parentLi) {
                const isAlreadyOpen = parentLi.classList.contains('active') || parentLi.classList.contains('active_click');

                // Close all other open submenus first (important for single-open menu behavior)
                closeAllOpenSubmenus();

                // If it was not already open, open it now
                if (!isAlreadyOpen) {
                    parentLi.classList.add('active_click'); // Or 'active' if you prefer
                    toggleButton.setAttribute('aria-expanded', 'true');
                    const submenu = parentLi.querySelector('.sub-menu');
                    if (submenu) {
                        submenu.style.visibility = 'visible'; // Or submenu.style.display = 'block';
                    }
                }
            }
        }
    });

    // --- Close submenu when clicking outside the entire megamenu (Existing code, looks fine for mouse interaction) ---
    document.addEventListener('click', (event) => {
        // If the click target is NOT inside the megamenu
        if (!event.target.closest('.megamenu')) {
            closeAllOpenSubmenus();
        }
    });

    // --- Handle Escape key to close the open submenu (Existing code, looks fine) ---
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            const currentOpenLi = megamenu.querySelector('li.with-sub-menu.active, li.with-sub-menu.active_click');
            if (currentOpenLi) {
                closeAllOpenSubmenus();
                // Return focus to the trigger button that opened it for a better user experience
                const toggleButton = currentOpenLi.querySelector('.custom_toggle-button');
                if (toggleButton) {
                    toggleButton.focus();
                }
            }
        }
    });
});